import { useAppContext } from "../context/app/context";

export function usePermission(functions: string[] | string): {
  [key: string]: boolean;
} {
  const { state } = useAppContext();
  functions = Array.isArray(functions) ? functions : [functions];
  const permissions =
    state.user?.permissions?.map((rec) => rec.functions).flat() || [];

  const output: any = {};
  functions.forEach((rec) => {
    output[rec] = permissions.includes(rec);
  });

  return output;
}
